export const BLOCK_EQUATION_NAME = 'block_equation'
export const INLINE_EQUATION_NAME = 'inline_equation'
export const REQUEST_OPEN_EDITOR_KEY = 'shouldOpenEquationEditor'
